import { subYears } from 'date-fns'
import { getTodayShortDate } from '~/core/functions/dates/getTodayShortDate'
import { newDateFromStr } from '~/core/utils/newDateFromStr'

export const getMinBirthDate = () => subYears(newDateFromStr(getTodayShortDate()), 100).toISOString().substring(0, 10)
